import { environment } from "../config/environment";

export function APIUrl(endpoint: string, pathParameter?: string) {
    const url = environment.API.BASE + endpoint + (pathParameter ? "/" + pathParameter : "")
    return url
}